//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/TransientObject.js";
import "../no/ugmath.js";
let d=[[[0,"CombDensity",1,1],[0,"CombInterneedleDensity",1,1],[0,"CombMaxLength",1,1],[0,"CombScaleFactor",1,1],[0,"Direction",1,1],[0,"DirectionOption",1,1],[0,"End",1,1],[0,"ShowComb",1,1],[0,"ShowInflection",1,1],[0,"ShowKnot",1,1],[0,"ShowPeak",1,1],[0,"ShowPole",1,1],[0,"Start",1,1],[0,"UseMaxLength",1,1]],[[[],"Dispose",{},0,1]],[]];
SPLM.GeometricAnalysis.CurveAnalysisRecord = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.CurveAnalysisRecord";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.CurveAnalysisRecord.DirectionOptionType = Object.freeze({
    "None" : "None", "PlaneOfCurve" : "PlaneOfCurve", "SpecifyVector" : "SpecifyVector", "WorkView" : "WorkView"});

export default SPLM;